import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'

const StepCheckedCircleWrapper = styled.div`
  width: ${rem(18)};
  height: ${rem(18)};
  background: ${({ theme }) => theme.palette.brand.primary.normal};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

function StepCheckedCircle() {
  return <StepCheckedCircleWrapper>
    <LineCheckIcon colour="neutral-eight" size={12} />
  </StepCheckedCircleWrapper>
}

export default StepCheckedCircle
